import { render, staticRenderFns } from "./searchInfo.vue?vue&type=template&id=3d5d20ce&"
import script from "./searchInfo.vue?vue&type=script&lang=js&"
export * from "./searchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports